import Part from "@/components/body/parts/part";
import { Colors } from "@/components/shared/util";
import { Patient } from "@/store/modules/patient/types";
import { Atom } from "@/store/types";
import SVG from "svg.js";
import { Store } from "vuex";
import { BodyConfig } from ".";
import SvgBarGraph from "./svgBarGraph";

const MAC_CAP = 1.2;
const MIN_OFFSET = 35;
const MAX_OFFSET = 120;
const OFFSET_RANGE = MAX_OFFSET - MIN_OFFSET;

export default class Brain extends Part {
  clipRect!: SVG.Rect;
  bis!: SvgBarGraph;
  icp!: SvgBarGraph;

  constructor(config: BodyConfig, container: SVG.Container, store: Store<any>) {
    super(config, container, store);

    const showBis = () => {
      this.action("brain");
    };
    this.bis = new SvgBarGraph(
      this.container,
      { x: 135, y: 33 },
      { title: "BIS" },
      this.showGreenGrayOnly,
      showBis
    );

    const showIcp = () => {
      this.action("Icp");
    };
    this.icp = new SvgBarGraph(
      this.container,
      { x: 160, y: 33 },
      { title: "ICP" },
      this.showGreenGrayOnly,
      showIcp
    );
  }

  updateBrightnessMode() {
    super.updateBrightnessMode();
    const color = this.dark ? Colors.White : Colors.Black;
    this.bis.title.attr({ fill: color });
    this.bis.value1.attr({ fill: color });
    this.bis.value2.attr({ fill: color });

    this.icp.title.attr({ fill: color });
    this.icp.value1.attr({ fill: color });
    this.icp.value2.attr({ fill: color });
  }

  getExtraData(data: Patient) {
    const bis = data.body.atoms.bis;
    const icp = data.body.atoms.icp;
    this.extraData = { bis, icp };
  }

  updateData(patient: Patient | null) {
    super.updateData(patient);

    this.bis.hide();
    this.icp.hide();

    if (this.bis) {
      if (this.extraData.bis && this.extraData.bis.age !== -1) {
        this.bis.show();
        this.bis.updateData(this.extraData.bis);
      } else {
        this.bis.hide();
      }
    }

    if (this.icp) {
      if (this.extraData.icp && this.extraData.icp.age !== -1) {
        this.icp.show();
        this.icp.updateData(this.extraData.icp);
      } else {
        this.icp.hide();
      }
    }

    if (!this.clipRect) {
      this.createClippingPath();
    }
    if (this.atom && this.config.atomId === "mac") {
      const y = this.calculateY(this.atom);
      this.clipRect.y(y);
    }
  }

  private createClippingPath() {
    const levelGroup = SVG.select(
      "#brainLevelGroup",
      this.container.node
    ).first() as SVG.Container;
    this.clipRect = levelGroup.rect(300, 150).move(200, 35);
    const clipContainer = this.container.clip();
    clipContainer.add(this.clipRect);
    levelGroup.clipWith(clipContainer);
  }

  private calculateY(atom: Atom) {
    const mac = atom.value;
    if (atom.level === 0) {
      // Show filled when there is no level
      return MIN_OFFSET;
    }
    if (mac >= MAC_CAP) {
      return MIN_OFFSET;
    } else {
      const percent = 1 * (mac / MAC_CAP);
      return OFFSET_RANGE * (1 - percent) + MIN_OFFSET;
    }
  }
}
